import { type App, reactive } from 'vue'

import { type VFormTrigger } from '../types.ts'
import { createHTTPClient } from './httpClient.ts'

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: Partial<T[P]>
    }
  : T

export type Config = DeepPartial<Omit<typeof config, 'merge' | 'app'>>

function merge(options: Config) {
  let component: keyof typeof options
  for (component in options) {
    Object.assign(config[component], options[component])
  }

  return config
}

export const configVDatePicker = reactive({
  displayFormat: 'YYYY-MM-DD',
})

export const configVDialog = reactive({
  closeOnClickOutside: false,
})

export const configVForm = reactive({
  validateOn: 'submit' as VFormTrigger,
  debounce: 300,
  resetOnDialogClose: false,
  httpClient: createHTTPClient(),
})

export const config = {
  VDatePicker: configVDatePicker,
  VDialog: configVDialog,
  VForm: configVForm,
  app: undefined as App | undefined,
  merge,
}
